module.exports = __webpack_public_path__ + "font/cccc9d29.woff2";